import { render, staticRenderFns } from "./AlphaGanith.vue?vue&type=template&id=7f09e74a&scoped=true&"
import script from "./AlphaGanith.vue?vue&type=script&lang=js&"
export * from "./AlphaGanith.vue?vue&type=script&lang=js&"
import style0 from "./AlphaGanith.vue?vue&type=style&index=0&id=7f09e74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f09e74a",
  null
  
)

export default component.exports